import React, { useState, useEffect } from "react";
import "../../assets/css/Career.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import CareerImage from "../../assets/image/Career/career-3.avif";
import Footer from "../Footer/Footer";

const Careers = () => {
  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [showEducation, setShowEducation] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    dob: "",
    contactNumber: "",
    email: "",
    position: "",
    source: "",
    currentAddress: "",
    permanentAddress: "",
  });

  const handleCancel = () => {
    setFormData({
      fullName: "",
      dob: "",
      contactNumber: "",
      email: "",
      position: "",
      source: "",
      currentAddress: "",
      permanentAddress: "",
    });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return (
    <>
      {/* Banner */}
      <div className="position-relative career-bg bg-light text-dark overflow-hidden min-vh-50 d-flex align-items-center">
        <div className="position-absolute top-0 start-0 w-100 h-100 opacity-20"></div>
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-lg-6 career-content">
              <nav aria-label="breadcrumb" className="mb-4">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="/"
                      className="text-white fw-bold text-decoration-none"
                    >
                      Home
                    </a>
                  </li>
                  <li
                    className="text-white fw-bold breadcrumb-item"
                    aria-current="page"
                  >
                    Careers
                  </li>
                </ol>
              </nav>
              <h3 className="display-5 fw-bold mb-3">Careers</h3>
            </div>
          </div>
        </div>
      </div>

      {/* Intro */}
      <div className="container mt-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-center align-items-center">
            <p className="font-para text-center">
              At{" "}
              <span className="font-red fw-bold">
                SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED
              </span>
              , we are building the future with cutting-edge technologies in Drone,
              Artificial Intelligence (AI), IoT, and Robotics. Whether you're a
              developer, engineer, designer, or innovator, your passion can grow with us.
            </p>
          </div>
        </div>
      </div>

      {/* Highlights */}
      <Container fluid className="mt-5">
        <Row className="align-items-center flex-column flex-lg-row">
          {/* Image Section */}
          <Col xs={12} lg={6} className="text-center mb-4 mb-lg-0">
            <Image
              src={CareerImage}
              alt="Career"
              fluid
              className="w-100"
              style={{ maxHeight: "400px", objectFit: "cover" }}
            />
          </Col>

          {/* Content Section */}
          <Col xs={12} lg={6}>
            <div className="mb-4">
              <h5 className="fw-bold font-red">Growing Career</h5>
              <p className="text-muted">
                At SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED, we don’t just offer jobs — we
                build careers. Whether you're starting out or experienced, we provide
                opportunities to work on real-world innovations in AI, drones, IoT, and
                robotics.
              </p>
            </div>
            <div className="mb-4">
              <h5 className="fw-bold font-red">Happy Work Environment</h5>
              <p className="text-muted">
                We believe innovation thrives in a positive environment. Our workplace
                encourages creativity, collaboration, and continuous learning, helping
                every individual grow while contributing to meaningful technology solutions.
              </p>
            </div>
            <div>
              <h5 className="fw-bold font-red">Rewards and Benefits</h5>
              <p className="text-muted">
                We value talent, dedication, and innovation. Our team members are rewarded
                with growth opportunities, skill development, and a culture that supports
                both personal and professional success.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Application Form */}
      <div className="container my-4">
        <h3 className="fw-bold font-black display-5 mb-4">
          Job <span className="text-[#00b7eb]">Application</span>
        </h3>

        {!showEducation ? (
          <div className="border p-4">
            <h5 className="text-center fw-bold mb-4">
              Personal <span className="font-red">Details</span>
            </h5>
            <form>
              <div className="row">
                {/* Left Column */}
                <div className="col-lg-6 mb-4">
                  {[
                    {
                      id: "fullName",
                      label: "Full Name",
                      type: "text",
                      placeholder: "Enter Full Name",
                    },
                    { id: "dob", label: "Date of Birth", type: "date" },
                    {
                      id: "contactNumber",
                      label: "Contact Number",
                      type: "text",
                      placeholder: "Enter Contact Number",
                    },
                    {
                      id: "email",
                      label: "Email Address",
                      type: "email",
                      placeholder: "Enter Email Address",
                    },
                  ].map(({ id, label, type, placeholder }) => (
                    <div className="mb-3" key={id}>
                      <label htmlFor={id} className="form-label fw-bold">
                        {label}
                      </label>
                      <input
                        type={type}
                        className="form-control"
                        id={id}
                        value={formData[id]}
                        onChange={handleChange}
                        placeholder={placeholder}
                      />
                    </div>
                  ))}
                </div>

                {/* Right Column */}
                <div className="col-lg-6 mb-4">
                  {/* Position Field */}
                  <div className="mb-3">
                    <label htmlFor="position" className="form-label fw-bold">
                      Enter Your Position
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="position"
                      value={formData.position}
                      onChange={handleChange}
                      placeholder="Enter Your Position"
                    />
                  </div>

                  {/* Source Dropdown */}
                  <div className="mb-3">
                    <label htmlFor="source" className="form-label fw-bold">
                      Select Source Type
                    </label>
                    <select
                      className="form-select"
                      id="source"
                      value={formData.source}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Source Type
                      </option>
                      <option value="LinkedIn">LinkedIn</option>
                      <option value="Indeed">Indeed</option>
                      <option value="Referral">Referral</option>
                    </select>
                  </div>

                  {/* Textareas */}
                  {[
                    {
                      id: "currentAddress",
                      label: "Current Address",
                      placeholder: "Enter Current Address",
                    },
                    {
                      id: "permanentAddress",
                      label: "Permanent Address",
                      placeholder: "Enter Permanent Address",
                    },
                  ].map(({ id, label, placeholder }) => (
                    <div className="mb-3" key={id}>
                      <label htmlFor={id} className="form-label fw-bold">
                        {label}
                      </label>
                      <textarea
                        rows={3}
                        className="form-control"
                        id={id}
                        value={formData[id]}
                        onChange={handleChange}
                        placeholder={placeholder}
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Buttons Row */}
              <div className="row">
                <div className="col-12 d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCancel}
                  >
                    CANCEL
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger text-white"
                    onClick={() => setShowEducation(true)}
                  >
                    NEXT
                  </button>
                </div>
              </div>
            </form>
          </div>
        ) : (
          <div className="border p-4">
            <h5 className="text-center fw-bold mb-4">
              Education <span className="font-red">Details</span>
            </h5>
            <form>
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  {[
                    {
                      id: "highest-qualification",
                      label: "Highest Qualification",
                      placeholder: "Enter Highest Qualification",
                    },
                    {
                      id: "university-name",
                      label: "University / Institution Name",
                      placeholder: "Enter University / Institution Name",
                    },
                  ].map(({ id, label, placeholder }) => (
                    <div className="mb-3" key={id}>
                      <label htmlFor={id} className="form-label fw-bold">
                        {label}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id={id}
                        placeholder={placeholder}
                      />
                    </div>
                  ))}
                  <div className="mb-3">
                    <label htmlFor="experience" className="form-label fw-bold">
                      Select Experience Year
                    </label>
                    <select className="form-select" id="experience">
                      <option disabled value="">
                        Select Experience Year
                      </option>
                      <option value="Fresher">Fresher</option>
                      <option value="Experience">Experience</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12">
                  {[
                    {
                      id: "field-study",
                      label: "Field Of Study",
                      placeholder: "Enter Field Of Study",
                    },
                    {
                      id: "graduation-year",
                      label: "Year Of Graduation",
                      placeholder: "Enter Year Of Graduation",
                    },
                  ].map(({ id, label, placeholder }) => (
                    <div className="mb-3" key={id}>
                      <label htmlFor={id} className="form-label fw-bold">
                        {label}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id={id}
                        placeholder={placeholder}
                      />
                    </div>
                  ))}
                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label fw-bold">
                      Upload File
                    </label>
                    <input className="form-control" type="file" id="formFile" />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-secondary text-white"
                  onClick={() => setShowEducation(false)}
                >
                  BACK
                </button>
                <button type="submit" className="btn btn-danger text-white">
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default Careers;
